import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import VideoAgreementCamera from "./VideoAgreementCamera";
import UploadError from "../../reusable/UploadError";
import VideoAgreementHelp from "./VideoAgreementHelp";


function VideoAgreement({side, inputChange, gizmo, verification}) {
    const { t } = useTranslation();
    const [takePicture, setTakePicture] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadingError, setUploadingError] = useState("");
    const [captured, setCaptured] = useState(null);

    const {script} = verification?.settings.reduce(
        (acc, setting) => {
            switch (setting.fieldName) {
                case "SCRIPT":
                    acc.script = setting.value;
                    break;
                default:
                    break;
            }
            return acc;
        },
        {
            script: null,
        }
    );

    const onCapture = (input) => {
        setCaptured(input)
        validateImage(input.value)
    }

    const validateImage = (generatedBlob) => {
        const fileName = `${verification?.verificationId}-agreement.mp4`
        setUploading(true)
        inputChange(
                [{
                document: {
                    name: fileName,
                    blob: generatedBlob
                },
                field: {
                    fieldName: side,
                    fileName: fileName,
                    value: fileName
                }
            }])
        setTakePicture(false)
    }

    const tryAgain = () => {
        setUploading(false)
        setTakePicture(false)
        setUploadingError("")
    }

    return (
        <div className="h-full w-full">
            {takePicture && <VideoAgreementCamera script={script} uploading={uploading} onCapture={onCapture} gizmo={gizmo} flowId={verification?.flowId} verificationId={verification?.verificationId}/>}
            {uploadingError && !takePicture &&
                <UploadError tryAgainFunc={tryAgain} imageSrc={captured} title={t("videoAgreement.uploadFailedTitle")}
                             desc={uploadingError}/>}
            {!takePicture && !uploadingError && !uploading && <VideoAgreementHelp openCamera={setTakePicture}/>}
        </div>
    );
}

export default VideoAgreement;
